import React, { useState, useEffect } from "react";
import { Dialog, FormGroup, InputGroup } from "@blueprintjs/core";
import { Tooltip, Icon, Position } from "@blueprintjs/core";
import Flexbox from "flexbox-react";
import { FilledButton, TextButton } from "../buttons-20250224T111359Z-001/buttons";
import ScrollableDropdown from "../shared/ScrollableDropdown";

const CheckInDialog = ({ isOpen, onClose, onSave, checkin, goalCycles }) => {
  const [form, setForm] = useState(checkin || { id: null, name: "" });

  const handleSave = () => {
    if (!form.name.trim()) return;
    onSave(form);
  };

  useEffect(() => {
    if (!isOpen) {
      setForm(checkin);
    }
  }, [isOpen]);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={form?.id ? "Edit Check-In" : "Create Check-In"}
      portalContainer={document.body}
      style={{
        width: "480px",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      {/* BODY */}
      <div style={{ padding: "24px" }}>
        
        {/* Subtitle */}
        <p style={{ marginBottom: "20px", color: "#6B7280", fontSize: "14px" }}>
          Create a check-in to track employee progress.
        </p>

        {/* Input */}
        <FormGroup
          label="Check-In Name"
          labelFor="name"
          style={{ marginBottom: "20px" }}
        >
          <InputGroup
            id="name"
            large
            placeholder="e.g. April Onboarding Batch"
            value={form.name}
            onChange={(e) =>
              setForm({ ...form, name: e.target.value })
            }
            style={{ borderRadius: "8px", marginTop:'5px' }}
          />
        </FormGroup>

        <FormGroup 
         label={
          <Flexbox alignItems="center" style={{ marginBottom: "0px" , paddingBottom: "0px" }}>
            <span style={{ marginBottom: "0px", paddingBottom: "0px" }}>Select Goal Cycle (Optional)</span>      
            <Tooltip portalContainer={document.body}
            boundary="viewport"
            interactionKind="hover"
             content={
              <div
                style={{
                  maxWidth: "240px",
                  whiteSpace: "normal",
                  lineHeight: "1.5"
                }}
              >
                If selected, this check-in will be associated with the chosen goal cycle.
                Progress, reminders for this check-in will be linked to that
                goal cycle. Leave it blank if the check-in is not tied to any goal cycle.
              </div>
            }
            
              position={Position.TOP}
              style={{ marginBottom: "0px", paddingBottom: "0px" }}
            >
              <Icon
                icon="info-sign"    
                size={14}
                color="#5C7080"
                style={{ cursor: "pointer", marginBottom: "2px", marginLeft: "2px" }}
              />
            </Tooltip>
          </Flexbox>
        }
        style={{ marginBottom: "0px", paddingBottom: "0px" }}
        >
        <ScrollableDropdown
          width={400}
          label={form.goal_setting_id ? goalCycles.find(goalCycle => goalCycle.id === form.goal_setting_id)?.title || "Select Goal Cycle" : "Select Goal Cycle"}
          items={goalCycles}
          getKey={goalCycle => goalCycle.id}
          getLabel={goalCycle => goalCycle.title || "Select Goal Cycle"}
          value={form.goal_setting_id}
          onSelect={(goalCycle) => setForm({ ...form, goal_setting_id: goalCycle.id })}
        />
        </FormGroup>

        <Flexbox flexDirection="row" gap="20px" justifyContent="flex-start" style={{ marginTop: "20px" }}>
      <FilledButton text="Save" onClick={handleSave} />
      <TextButton text="Cancel" onClick={onClose} />
     
      </Flexbox>
      </div>          
    </Dialog>
  );
};

export default CheckInDialog;